var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18 5V15C18 18 16.5 20 13 20H5C1.5 20 0 18 0 15V5C0 2 1.5 0 5 0H13C16.5 0 18 2 18 5Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.25H13.5C11.98 7.25 10.75 6.02 10.75 4.5V2.5C10.75 2.09 11.09 1.75 11.5 1.75C11.91 1.75 12.25 2.09 12.25 2.5V4.5C12.25 5.19 12.81 5.75 13.5 5.75H15.5C15.91 5.75 16.25 6.09 16.25 6.5C16.25 6.91 15.91 7.25 15.5 7.25Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.75H5C4.59 11.75 4.25 11.41 4.25 11C4.25 10.59 4.59 10.25 5 10.25H9C9.41 10.25 9.75 10.59 9.75 11C9.75 11.41 9.41 11.75 9 11.75Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H5C4.59 15.75 4.25 15.41 4.25 15C4.25 14.59 4.59 14.25 5 14.25H13C13.41 14.25 13.75 14.59 13.75 15C13.75 15.41 13.41 15.75 13 15.75Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentActive);
export default __webpack_public_path__ + "static/media/document-active.1b6ee09055d22623888257c4074cb9d2.svg";
export { ForwardRef as ReactComponent };